import content from '../content.json'
import {Input} from '../../../../../components/input/Input'
import {Button} from '../../../../../components/button/Button'
import config from '../../../../../config'
import {useNavigate} from 'react-router'
import PriceFeatures from './PriceFeatures'

const PriceCard = ({ price, discount }) => {
    const navigate = useNavigate()

    return (
        <div className={'pricing-cards'}>
            <div className={'price-card'}>
                <div className={'price-header'}>
                    <div className={'price-info'}>
                        <span className={'regular-price'}>${price}</span>
                        <span className={'discount-price'}>
                            ${(price - price * discount).toFixed(2)}
                        </span>
                        <span className={'currency'}>{content?.currency}</span>
                    </div>
                    <span className={'period'}>{content?.frequency}</span>
                </div>
                <div className={'input-info-wrapper'}>
                    <Input
                        id={'num-of-responses'}
                        label={content?.responseLimitLabel}
                        type='text'
                        readOnly={true}
                        value={content?.responseLimit}
                        infoMsg={content?.responseLimitMsg}
                    />
                </div>
                {/*<input*/}
                {/*    aria-label={'Select price'}*/}
                {/*    type={'range'}*/}
                {/*    min={min}*/}
                {/*    max={max}*/}
                {/*    value={price}*/}
                {/*    step={20}*/}
                {/*/>*/}
                <hr/>
               <PriceFeatures content={content} />
                <Button variant={'primary'} onClick={() => navigate(config.root + '/signup')}>
                    {content?.buttonText}
                </Button>
            </div>
        </div>
    )
}

export default PriceCard